
import { Component, Vue, Ref } from 'vue-property-decorator'
import { WinpressService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import FullLoading from '@/components/full_loading/index.vue'
import DemandTable from './components/list_table.vue'
// eslint-disable-next-line
import ScrollToType from '@/components/scroll_to/type'

const statusMap = {
    all: {
        value: '', name: '全部'
    },
    pedding: {
        value: 1, name: '未处理'
    },
    resolve: {
        value: 2, name: '已处理'
    }
}

const typeMap = {
    all: {
        value: '', name: '全部'
    },
    forum: {
        value: 1, name: '高峰论坛'
    },
    publish: {
        value: 2, name: '产品发布'
    },
    ceremony: {
        value: 3, name: '签约仪式'
    }
}

@Component({
    name: 'demand-list',
    components: {
        ScrollTo,
        FullLoading,
        DemandTable
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = false
    private status = statusMap.all.value
    private type = typeMap.all.value
    private statusMap = statusMap
    private typeMap = typeMap
    private demands = []
    
    private mounted() {
        this.getDemandList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getDemandList()
    }

    private async getDemandList() {
        const params = {
            status: this.status,
            type: this.type,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await WinpressService.getWpDemandList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.demands = result.data.list.map((n: any) => ({ ...n, old_status: n.status.id }))
        }
    }

    private async onStatusChange({ status, item }: any) {
        const params = { id: item.id, status }
        const result = await WinpressService.updateWpDemandStatus(params)
        if (result.status === 200) {
            this.$msuccess('修改成功')
        } else {
            this.$merror(result.message || '发生错误, 请稍后再试')
            item.status.id = item.old_status
        }
    }
}
